/**
 * Included into the footer of pages.
 */

import './lib/AnimationEasing';

import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	// customPlayButton: require("./component/VideoModal/VideoModal.svg?string")
});

// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance(
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .site-footer__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .site-footer__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// );
// ---------------------------------------------------------------------------------------------- //



//======================================================================
// Awards Counter
//======================================================================
// import './component/Awards/Awards.js';
//======================================================================



// Bind jQuery to $ in this module (WordPress uses noConflict)
const $ = (window as any).jQuery;

// ============================================================================
// Contols the Sliding in/out of the Page Header
// ============================================================================
var lastScrollTop = 0;
var isHeaderHidden = false;
var currentScrollTop = 0;

$(window).on('scroll', function() {
	currentScrollTop = $(window).scrollTop() ?? 0;

	if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
		// User is scrolling down and has scrolled at least 100px
		$('.plaudit-site-header').addClass('hide');
		$('.plaudit-site-header').removeClass('show');
		isHeaderHidden = true;
	} else if (isHeaderHidden && currentScrollTop < (lastScrollTop - 10)) {
		// User is scrolling up and has scrolled up at least 100px from their current position
		$('.plaudit-site-header').removeClass('hide');
		$('.plaudit-site-header').addClass('show');
		isHeaderHidden = false;
	}

	if (currentScrollTop > 250) {
		// User has scrolled more than 250px from the top
		$('.plaudit-site-header').addClass('hasBkgd');
	} else {
		// User has scrolled less than 250px from the top
		$('.plaudit-site-header').removeClass('hasBkgd');
	}

	lastScrollTop = currentScrollTop;
});